import { Button, Col, Form, Row } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useTranslation } from 'react-i18next';

interface FilterProps {
  handleChangeName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  callFilter: () => void;
  name?: string;
}

function Filter({ handleChangeName, callFilter, name }: FilterProps) {
  const { t } = useTranslation();
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{t('GenreAddModal.search')}</Accordion.Header>
          <Accordion.Body>
            <Form.Group as={Row}>
              <Col sm={2} md={2} lg={2} xl={2}>
                {t('GenreAddModal.name')}
              </Col>
              <Col sm={8} md={8} lg={8} xl={8}>
                <Form.Control type="text" onChange={handleChangeName} />
              </Col>
              <Col sm={2} md={2} lg={2} xl={2}>
                <Button variant="primary" onClick={callFilter}>
                  {t('GenreAddModal.search')}
                </Button>
              </Col>
            </Form.Group>
          </Accordion.Body>
          <div className="accordion-body accordion-summary">
            <Row>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('GenreAddModal.name')} {name}
                </Form.Label>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </>
  );
}
export default Filter;
